module.exports = __webpack_public_path__ + "media/images/checkout_hero-05ec311a.svg";